export default __webpack_public_path__ + "static/media/uk.96cd2aaa.png";